// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"uninstall"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21H21V15H3V21Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.5 3.00012H3V21.0001H21V3.00012H17.5M21 21H3V15H21V21ZM6.99805 17.9981H7.00195V18.002H6.99805V17.9981ZM9.99805 17.9981H10.002V18.002H9.99805V17.9981Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.5 6.46021L12 3L15.5 6.46021M12 4.19998V11.5041","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UninstallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'uninstall',
    ref,
    icon: element,
  },
));

UninstallIcon.displayName = 'UninstallIcon';

export default UninstallIcon;
